import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { config } from "@config";
import { SegmentService } from "@main-services/segment.service";

@Component({
	selector: "global-warning",
	templateUrl: "./global-warning.component.html",
	styleUrls: ["./global-warning.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class GlobalWarningComponent {
	private segmentService = inject(SegmentService);

	getUrl(): string {
		return config.baseUrl + config.externalPaths["uk_finprom_risk_warning"]["link"];
	}

	public trackClickEvent(): void {
		this.segmentService.track({ name: "UK Risk Summary banner clicked" });
	}
}
